import { Router } from "vue-router";
import router from "@/common/router/index";

export const getCurrentUrl = () => {
  console.log("router : ", router);
  console.log("_> : ", router.currentRoute.value.fullPath);
  return router.currentRoute.value.fullPath;
};

export const getCurrentFullRoute = () => {
  const { fullPath, query, path } = router.currentRoute.value;

  // fullPath는 문자열로 전체 URL (e.g., /lotto/generate?qrData=xxx)
  // query는 객체 형태 (e.g., { qrData: '...' })

  return {
    path,
    query,
    fullPath, // optional, 로그 확인용
  };
};

/**
 * 현재 주소에서 URL 의 nextRoute 를 반환한다.
 * @returns nextRoute={path=aaa&param1=value1...}
 */
export const getNextRoute = () => {
  console.log("getNextRoute : ", router.currentRoute.value.query.nextRoute);
  return router.currentRoute.value.query.nextRoute;
};

/**
 * 라우트 이동시 현재 페이지 정보를 전달하기 위해 nextRoute 생성쿼리
 * @param extraQuery query 로 추가하고 싶은 key-value 객체
 * @returns nextRoute -> moveTo 2번째 인자로 사용
 */
export const getCreateNextRoute = (extraQuery: Record<string, any> = {}) => {
  const currentRoute = router.currentRoute.value;

  const mergedQuery = {
    ...currentRoute.query,
    ...extraQuery,
  };

  return encodeURIComponent(
    JSON.stringify({
      path: currentRoute.path,
      query: mergedQuery,
    })
  );
};

export const getCurrentNextRoute = () => {
  const nextRoute = getNextRoute();
  if (typeof nextRoute === "string") {
    try {
      const decodedStr = decodeURIComponent(nextRoute); // 문자열 디코딩
      const parsedRoute = JSON.parse(decodedStr); // JSON 파싱
      return parsedRoute.query;
    } catch (err) {
      console.error("❌ nextRoute decode or parse error:", err);
      return {};
    }
  }
};

// export const moveTo = (url: string, nextUrl?: string) => {
//   router
//     .push({
//       path: url,
//       query: { nextUrl: nextUrl },
//     })
//     .catch((err) => {
//       console.error("Router navigation error : ", err);
//     });
// };

/**
 * Router 이동 함수
 * @param url 이동하고자 하는 router
 * @param nextRoute 완료 후 이동하고자 하는 페이지 정보
 */
export const moveTo = (url: string, nextRoute?: string) => {
  console.log("====== moveTo ======");
  console.log("url : ", url);
  console.log("nextRoute : ", nextRoute);
  router
    .push({
      path: url,
      query: nextRoute ? { nextRoute } : undefined,
    })
    .then(() => {
      // if (!nextRoute) {
      window.history.replaceState({}, "", url);
      // }
    })
    .catch((err) => {
      console.error("Router navigation error : ", err);
    });
};

export const open = (url: string) => {
  window.open(url, "_blank", "noopener,noreferrer");
};

export const getNextUrl = () => {
  const nextUrl = router.currentRoute.value.query.nextUrl;
  return typeof nextUrl === "string" ? nextUrl : null;
};

export const logoutAndRedirectHome = () => {
  const requiresAuth = router.currentRoute.value.meta.auth;

  if (requiresAuth) {
    router.push({ path: "/" }).catch((err) => {
      console.error("Router navigation error during logout: ", err);
    });
  } else {
    console.log("Logout without redirection needed.");
  }
};
/**
 * 이전 페이지로 이동
 * @param router - Vue Router 인스턴스
 */
// export const goBack = (router: Router) => {
//   router.back();
// };

export const goBack = () => {
  router.back();
};

/**
 * 쿼리 파라미터 설정 함수
 * @param router - Vue Router 인스턴스
 * @param query - 설정할 쿼리 파라미터 객체
 */
export const setQueryParams = (router: Router, query: Record<string, any>) => {
  const currentRoute = router.currentRoute.value;
  router
    .push({
      path: currentRoute.path,
      query: { ...currentRoute.query, ...query },
    })
    .catch((err) => {
      console.error("Failed to set query params:", err);
    });
};

/**
 * 페이지 리로딩
 * @param router - Vue Router 인스턴스
 */
export const reloadPage = (router: Router) => {
  const currentRoute = { ...router.currentRoute.value };
  router
    .push({ path: "/empty" })
    .then(() => {
      router.push(currentRoute);
    })
    .catch((err) => {
      console.error("Failed to reload page:", err);
    });
};

/**
 * 특정 경로로 리다이렉트
 * @param router - Vue Router 인스턴스
 * @param path - 리다이렉트할 경로
 */
export const redirectTo = (router: Router, path: string) => {
  router.replace(path).catch((err) => {
    console.error("Failed to redirect:", err);
  });
};
